import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TrafficFinesService, TrafficFineUnlinkedItem } from '../../../services/traffic-fines.service';

@Component({
  selector: 'app-traffic-fines-unlinked',
  templateUrl: './traffic-fines-unlinked.component.html',
  styleUrls: ['./traffic-fines-unlinked.component.css']
})
export class TrafficFinesUnlinkedComponent implements OnInit {
  loading = true;
  error = '';
  total = 0;
  itens: TrafficFineUnlinkedItem[] = [];
  filtro = '';
  sortField: 'aipNumber' | 'placa' | 'contratante' | 'infractionDateTime' = 'infractionDateTime';
  sortDesc = true;

  constructor(
    private trafficFines: TrafficFinesService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.trafficFines.listSemVinculo().subscribe({
      next: body => {
        this.total = body.total ?? 0;
        this.itens = body.itens ?? [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.error = 'Não foi possível carregar as multas sem vínculo.';
      }
    });
  }

  get visiveis(): TrafficFineUnlinkedItem[] {
    const term = this.filtro.trim().toLowerCase();
    const rows = !term
      ? this.itens
      : this.itens.filter(item =>
        (item.aipNumber || '').toLowerCase().includes(term)
        || (item.placa || '').toLowerCase().includes(term)
        || (item.contratante || '').toLowerCase().includes(term)
      );
    const dir = this.sortDesc ? -1 : 1;
    return [...rows].sort((a, b) => this.comparar(a, b) * dir);
  }

  ordenar(field: 'aipNumber' | 'placa' | 'contratante' | 'infractionDateTime'): void {
    if (this.sortField === field) {
      this.sortDesc = !this.sortDesc;
      return;
    }
    this.sortField = field;
    this.sortDesc = field === 'infractionDateTime';
  }

  seta(field: 'aipNumber' | 'placa' | 'contratante' | 'infractionDateTime'): string {
    if (this.sortField !== field) return '';
    return this.sortDesc ? ' ↓' : ' ↑';
  }

  abrir(item: TrafficFineUnlinkedItem): void {
    void this.router.navigate(['/financial/traffic-fines', item.id, 'view']);
  }

  private comparar(a: TrafficFineUnlinkedItem, b: TrafficFineUnlinkedItem): number {
    if (this.sortField === 'infractionDateTime') {
      const ta = a.infractionDateTime ? new Date(a.infractionDateTime).getTime() : 0;
      const tb = b.infractionDateTime ? new Date(b.infractionDateTime).getTime() : 0;
      return ta - tb;
    }
    const va = String(a[this.sortField] ?? '');
    const vb = String(b[this.sortField] ?? '');
    return va.localeCompare(vb, 'pt', { sensitivity: 'base' });
  }
}
